var LG_6711A90031Y = {
  name: "LG 6711A90031Y",
  defaultCommandIndex: 1,
  commands: [
    {
      mode: "AC_MODE_OFF",
      temperature: "AC_TEMP_NULL",
      fan: "AC_FAN_NULL",
      command: [59,0,4,39,2,176,1,4,34,123,15,84,2,162,5,16,2,0,0,79,60,159,254,103,145,0],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_AUTO",
      command: [59,0,4,18,2,204,1,230,33,170,15,74,2,160,5,21,2,0,0,79,63,255,38,100,241,0],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_AUTO",
      command: [59,0,4,19,2,194,1,10,34,130,15,78,2,160,5,6,2,0,0,79,63,254,121,147,145,0],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_AUTO",
      command: [59,0,4,10,2,178,1,40,34,123,15,73,2,175,5,61,2,0,0,79,63,254,102,100,204,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_AUTO",
      command: [59,0,4,14,2,205,1,222,33,162,15,75,2,162,5,19,2,0,0,79,63,254,78,100,201,16],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_AUTO",
      command: [59,0,4,18,2,201,1,29,34,110,15,80,2,165,5,34,2,0,0,79,63,254,73,153,39,16],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_AUTO",
      command: [59,0,4,9,2,186,1,232,33,156,15,79,2,170,5,19,2,0,0,79,63,252,249,146,100,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_AUTO",
      command: [59,0,4,23,2,202,1,0,34,131,15,72,2,162,5,61,2,0,0,79,63,252,230,100,147,16],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_AUTO",
      command: [59,0,4,4,2,205,1,233,33,159,15,75,2,174,5,18,2,0,0,79,63,252,206,100,146,68],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_AUTO",
      command: [59,0,4,14,2,202,1,231,33,167,15,79,2,162,5,21,2,0,0,79,63,252,201,153,241,0],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_AUTO",
      command: [59,0,4,11,2,204,1,237,33,164,15,74,2,160,5,5,2,0,0,79,63,252,158,103,145,0],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_AUTO",
      command: [59,0,4,8,2,207,1,223,33,171,15,72,2,167,5,56,2,0,0,79,63,252,153,153,204,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_AUTO",
      command: [59,0,4,19,2,206,1,84,2,156,5,10,34,118,15,19,2,0,0,47,127,250,187,117,16],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_AUTO",
      command: [59,0,4,14,2,205,1,105,2,163,5,9,34,101,15,43,2,0,0,47,127,250,173,183,16],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_LOW",
      command: [59,0,4,14,2,205,1,228,33,170,15,75,2,164,5,10,2,0,0,79,63,255,39,242,68],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_LOW",
      command: [59,0,4,17,2,206,1,7,34,167,15,76,2,160,5,18,2,0,0,79,63,254,127,156,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_LOW",
      command: [59,0,4,9,2,202,1,217,33,135,15,113,2,175,5,6,2,0,0,79,63,254,103,230,68],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_LOW",
      command: [59,0,4,10,2,202,1,254,33,150,15,85,2,169,5,8,2,0,0,79,63,254,79,228,196],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_LOW",
      command: [59,0,4,19,2,205,1,251,33,144,15,75,2,163,5,25,2,0,0,79,63,254,73,249,36,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_LOW",
      command: [59,0,4,6,2,211,1,36,34,103,15,88,2,170,5,28,2,0,0,79,63,252,255,60,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_LOW",
      command: [59,0,4,15,2,199,1,5,34,123,15,83,2,171,5,13,2,0,0,79,63,252,231,206,68],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_LOW",
      command: [59,0,4,14,2,204,1,7,34,132,15,73,2,160,5,26,2,0,0,79,63,252,207,204,196],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_LOW",
      command: [59,0,4,3,2,204,1,240,33,155,15,83,2,178,5,7,2,0,0,79,63,252,201,243,36,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_LOW",
      command: [59,0,4,7,2,204,1,76,2,170,5,5,34,130,15,19,2,0,0,47,127,250,254,184,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_LOW",
      command: [59,0,4,13,2,206,1,244,33,153,15,83,2,162,5,38,2,0,0,79,63,252,153,242,100,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_LOW",
      command: [59,0,4,21,2,208,1,33,34,114,15,76,2,151,5,44,2,0,0,79,63,252,147,242,76,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_LOW",
      command: [59,0,4,13,2,204,1,0,34,149,15,70,2,162,5,12,2,0,0,79,63,252,146,124,146,68],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_MID",
      command: [59,0,4,3,2,205,1,8,34,123,15,79,2,177,5,13,2,0,0,79,63,255,39,57,145,0],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_MID",
      command: [59,0,4,2,2,206,1,234,33,153,15,84,2,177,5,23,2,0,0,79,63,254,124,228,196],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_MID",
      command: [59,0,4,23,2,181,1,229,33,162,15,77,2,148,5,22,2,0,0,79,63,254,103,57,36,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_MID",
      command: [59,0,4,16,2,199,1,233,33,158,15,78,2,164,5,23,2,0,0,79,63,254,79,51,196],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_MID",
      command: [59,0,4,3,2,205,1,255,33,122,15,109,2,172,5,22,2,0,0,79,63,254,73,204,228,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_MID",
      command: [59,0,4,5,2,202,1,5,34,128,15,82,2,177,5,23,2,0,0,79,63,252,252,204,196],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_MID",
      command: [59,0,4,12,2,182,1,29,34,129,15,73,2,173,5,17,2,0,0,79,63,252,231,51,36,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_MID",
      command: [59,0,4,6,2,200,1,241,33,144,15,91,2,175,5,20,2,0,0,79,63,252,207,50,113,0],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_MID",
      command: [59,0,4,40,2,145,1,31,34,112,15,81,2,162,5,21,2,0,0,79,63,252,201,204,153,16],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_MID",
      command: [59,0,4,5,2,206,1,237,33,155,15,83,2,175,5,9,2,0,0,79,63,252,159,50,76,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_MID",
      command: [59,0,4,17,2,184,1,24,34,114,15,82,2,157,5,2,2,0,0,79,63,252,153,204,146,68],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_MID",
      command: [59,0,4,14,2,203,1,31,34,117,15,74,2,159,5,20,2,0,0,79,63,252,147,207,196],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_MID",
      command: [59,0,4,13,2,204,1,234,33,164,15,70,2,161,5,45,2,0,0,79,63,252,146,115,228,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_HIGH",
      command: [59,0,4,20,2,196,1,252,33,158,15,77,2,161,5,4,2,0,0,79,63,255,38,121,36,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_HIGH",
      command: [59,0,4,13,2,202,1,235,33,162,15,78,2,164,5,39,2,0,0,79,63,254,121,207,16],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_HIGH",
      command: [59,0,4,3,2,204,1,27,34,110,15,77,2,175,5,3,2,0,0,79,63,254,102,115,145,0],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_HIGH",
      command: [59,0,4,17,2,200,1,18,34,153,15,72,2,162,5,22,2,0,0,79,63,254,78,115,49,0],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_HIGH",
      command: [59,0,4,20,2,203,1,230,33,155,15,82,2,157,5,13,2,0,0,79,63,254,73,156,201,16],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_HIGH",
      command: [59,0,4,4,2,202,1,234,33,156,15,83,2,178,5,19,2,0,0,79,63,252,249,201,196],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_HIGH",
      command: [59,0,4,12,2,206,1,226,33,175,15,72,2,166,5,40,2,0,0,79,63,252,230,114,100,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_HIGH",
      command: [59,0,4,13,2,208,1,29,34,105,15,85,2,162,5,60,2,0,0,79,63,252,206,114,76,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_HIGH",
      command: [59,0,4,26,2,196,1,36,34,110,15,81,2,155,5,18,2,0,0,79,63,252,201,156,146,68],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_HIGH",
      command: [59,0,4,12,2,206,1,252,33,174,15,78,2,159,5,22,2,0,0,79,63,252,158,127,16],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_HIGH",
      command: [59,0,4,12,2,211,1,232,33,171,15,77,2,160,5,7,2,0,0,79,63,252,153,159,145,0],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_HIGH",
      command: [59,0,4,17,2,203,1,38,34,106,15,83,2,158,5,22,2,0,0,79,63,252,147,159,49,0],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_HIGH",
      command: [59,0,4,9,2,205,1,24,34,106,15,83,2,166,5,6,2,0,0,79,63,252,146,103,201,16],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_AUTO",
      command: [59,0,4,3,2,203,1,228,33,171,15,74,2,175,5,16,2,0,0,79,63,231,230,100,204,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_AUTO",
      command: [59,0,4,22,2,206,1,229,33,163,15,83,2,146,5,24,2,0,0,79,63,231,206,100,201,16],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_AUTO",
      command: [59,0,4,13,2,182,1,234,33,164,15,72,2,164,5,66,2,0,0,79,63,231,201,153,39,16],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_AUTO",
      command: [59,0,4,14,2,206,1,232,33,170,15,75,2,157,5,12,2,0,0,79,63,231,158,100,153,16],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_AUTO",
      command: [59,0,4,20,2,211,1,6,34,128,15,79,2,150,5,20,2,0,0,79,63,231,153,153,36,196],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_AUTO",
      command: [59,0,4,11,2,210,1,107,2,166,5,235,33,130,15,22,2,0,0,47,127,222,187,85,68],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_AUTO",
      command: [59,0,4,20,2,204,1,2,34,129,15,78,2,150,5,35,2,0,0,79,63,231,146,102,124,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_AUTO",
      command: [59,0,4,36,2,169,1,48,34,123,15,75,2,160,5,22,2,0,0,79,63,231,62,103,145,0],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_AUTO",
      command: [59,0,4,20,2,200,1,3,34,124,15,82,2,152,5,23,2,0,0,79,63,231,57,153,204,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_AUTO",
      command: [59,0,4,20,2,205,1,86,2,154,5,233,33,154,15,29,2,0,0,47,127,221,187,117,16],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_AUTO",
      command: [59,0,4,3,2,207,1,71,2,175,5,2,34,152,15,22,2,0,0,47,127,221,173,183,16],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_AUTO",
      command: [59,0,4,14,2,205,1,255,33,139,15,82,2,162,5,22,2,0,0,79,63,231,39,153,153,16],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_AUTO",
      command: [59,0,4,18,2,187,1,110,2,159,5,34,34,80,15,62,2,0,0,47,127,221,109,181,136],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_AUTO",
      command: [59,0,4,21,2,208,1,75,2,151,5,250,33,161,15,25,2,0,0,47,127,221,93,181,68],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_AUTO",
      command: [59,0,4,14,2,210,1,91,2,159,5,8,34,116,15,28,2,0,0,47,127,221,86,215,136],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_LOW",
      command: [59,0,4,3,2,207,1,0,34,123,15,86,2,177,5,22,2,0,0,79,63,231,231,230,68],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_LOW",
      command: [59,0,4,22,2,207,1,3,34,122,15,83,2,156,5,55,2,0,0,79,63,231,207,228,196],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_LOW",
      command: [59,0,4,4,2,187,1,2,34,106,15,103,2,173,5,20,2,0,0,79,63,231,201,249,36,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_LOW",
      command: [59,0,4,19,2,203,1,0,34,130,15,80,2,158,5,62,2,0,0,79,63,231,159,207,16],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_LOW",
      command: [59,0,4,1,2,205,1,236,33,162,15,79,2,176,5,27,2,0,0,79,63,231,153,243,145,0],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_LOW",
      command: [59,0,4,17,2,215,1,1,34,131,15,77,2,151,5,27,2,0,0,79,63,231,147,243,49,0],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_LOW",
      command: [59,0,4,16,2,208,1,36,34,122,15,71,2,162,5,25,2,0,0,79,63,231,146,124,201,16],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_LOW",
      command: [59,0,4,16,2,203,1,21,34,107,15,85,2,159,5,22,2,0,0,79,63,231,63,201,196],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_LOW",
      command: [59,0,4,6,2,200,1,61,34,120,15,72,2,176,5,25,2,0,0,79,63,231,57,242,100,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_LOW",
      command: [59,0,4,25,2,172,1,21,34,128,15,74,2,175,5,31,2,0,0,79,63,231,51,242,76,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_LOW",
      command: [59,0,4,21,2,197,1,36,34,122,15,82,2,156,5,28,2,0,0,79,63,231,50,124,146,68],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_LOW",
      command: [59,0,4,3,2,209,1,236,33,162,15,78,2,175,5,23,2,0,0,79,63,231,39,255,16],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_LOW",
      command: [59,0,4,19,2,207,1,22,34,96,15,102,2,156,5,3,2,0,0,79,63,231,38,127,145,0],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_LOW",
      command: [59,0,4,21,2,212,1,31,34,108,15,80,2,150,5,20,2,0,0,79,63,231,36,255,49,0],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_LOW",
      command: [59,0,4,23,2,192,1,226,33,163,15,78,2,145,5,28,2,0,0,79,63,231,36,159,201,16],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_MID",
      command: [59,0,4,23,2,191,1,227,33,169,15,78,2,157,5,19,2,0,0,79,63,231,231,57,36,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_MID",
      command: [59,0,4,3,2,205,1,36,34,124,15,85,2,175,5,20,2,0,0,79,63,231,207,51,196],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_MID",
      command: [59,0,4,3,2,206,1,8,34,131,15,78,2,173,5,18,2,0,0,79,63,231,201,204,228,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_MID",
      command: [59,0,4,16,2,208,1,226,33,180,15,64,2,155,5,25,2,0,0,79,63,231,159,51,49,0],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_MID",
      command: [59,0,4,7,2,185,1,27,34,114,15,77,2,172,5,21,2,0,0,79,63,231,153,204,201,16],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_MID",
      command: [59,0,4,1,2,207,1,0,34,144,15,78,2,176,5,21,2,0,0,79,63,231,147,204,156,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_MID",
      command: [59,0,4,21,2,211,1,255,33,132,15,74,2,148,5,7,2,0,0,79,63,231,146,115,38,68],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_MID",
      command: [59,0,4,3,2,204,1,29,34,110,15,83,2,175,5,24,2,0,0,79,63,231,63,50,76,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_MID",
      command: [59,0,4,15,2,205,1,233,33,163,15,73,2,162,5,12,2,0,0,79,63,231,57,204,146,68],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_MID",
      command: [59,0,4,16,2,200,1,232,33,162,15,77,2,164,5,35,2,0,0,79,63,231,51,207,196],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_MID",
      command: [59,0,4,19,2,205,1,228,33,174,15,73,2,155,5,61,2,0,0,79,63,231,50,115,228,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_MID",
      command: [59,0,4,20,2,204,1,23,34,123,15,78,2,156,5,20,2,0,0,79,63,231,39,207,49,0],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_MID",
      command: [59,0,4,21,2,203,1,2,34,154,15,83,2,151,5,20,2,0,0,79,63,231,38,115,201,16],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_MID",
      command: [59,0,4,22,2,203,1,71,2,147,5,248,33,154,15,27,2,0,0,47,127,221,94,238,32],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_MID",
      command: [59,0,4,17,2,208,1,237,33,146,15,91,2,157,5,8,2,0,0,79,63,231,36,156,230,68],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_16",
      fan: "AC_FAN_HIGH",
      command: [59,0,4,20,2,198,1,3,34,126,15,80,2,161,5,16,2,0,0,79,63,231,230,115,145,0],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_17",
      fan: "AC_FAN_HIGH",
      command: [59,0,4,3,2,207,1,0,34,138,15,85,2,176,5,28,2,0,0,79,63,231,206,115,49,0],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_HIGH",
      command: [59,0,4,17,2,206,1,2,34,127,15,76,2,160,5,59,2,0,0,79,63,231,201,156,201,16],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_HIGH",
      command: [59,0,4,6,2,201,1,7,34,122,15,85,2,175,5,29,2,0,0,79,63,231,158,114,113,0],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_HIGH",
      command: [59,0,4,15,2,191,1,233,33,144,15,102,2,160,5,20,2,0,0,79,63,231,153,156,153,16],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_HIGH",
      command: [59,0,4,16,2,201,1,2,34,145,15,76,2,165,5,20,2,0,0,79,63,231,147,156,147,16],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_HIGH",
      command: [59,0,4,23,2,205,1,69,2,149,5,250,33,152,15,29,2,0,0,47,127,222,173,213,68],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_HIGH",
      command: [59,0,4,18,2,205,1,90,2,159,5,2,34,122,15,27,2,0,0,47,127,221,247,241,0],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_HIGH",
      command: [59,0,4,16,2,208,1,27,34,104,15,85,2,155,5,24,2,0,0,79,63,231,57,159,145,0],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_HIGH",
      command: [59,0,4,41,2,168,1,74,2,158,5,31,34,121,15,28,2,0,0,47,127,221,187,236,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_HIGH",
      command: [59,0,4,16,2,196,1,28,34,120,15,86,2,175,5,42,2,0,0,79,63,231,50,103,201,16],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_HIGH",
      command: [59,0,4,17,2,204,1,32,34,113,15,80,2,158,5,33,2,0,0,79,63,231,39,158,113,0],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_HIGH",
      command: [59,0,4,18,2,202,1,232,33,163,15,75,2,157,5,17,2,0,0,79,63,231,38,103,153,16],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_HIGH",
      command: [59,0,4,37,2,205,1,83,2,127,5,10,34,122,15,30,2,0,0,47,127,221,93,235,16],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_HIGH",
      command: [59,0,4,74,2,149,5,21,2,212,1,37,34,114,15,18,2,0,0,53,106,170,181,246,175,16],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_NULL",
      fan: "AC_FAN_AUTO",
      command: [59,0,4,2,2,204,1,83,2,177,5,254,33,118,15,60,2,0,0,47,127,186,251,107,16],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_NULL",
      fan: "AC_FAN_LOW",
      command: [59,0,4,18,2,200,1,225,33,158,15,88,2,165,5,40,2,0,0,79,63,206,79,254,68],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_NULL",
      fan: "AC_FAN_MID",
      command: [59,0,4,16,2,190,1,229,33,174,15,70,2,178,5,12,2,0,0,79,63,206,79,207,36,64],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_NULL",
      fan: "AC_FAN_HIGH",
      command: [59,0,4,22,2,202,1,72,2,159,5,2,34,130,15,30,2,0,0,47,127,186,251,218,32],
    },
    ]
};

export default LG_6711A90031Y
